var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"type":"is-light","disabled":!_vm.canScrap || _vm.isLoading,"loading":!_vm.canScrap || _vm.isLoading},on:{"click":function($event){$event.preventDefault();return _vm.scrapUniqueUrl.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-redo-alt"})]),_c('Toaster',{ref:"toaster"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }